export default function trackEvent(
  category: string,
  action: string,
  label: string
): void {
  if (!window.ga) {
    return
  }

  try {
    window.ga('send', 'event', category, action, label)
  } catch (e) {
    window.Sentry.captureException(e)
  }
}
